export const firebaseConfig = {
    apiKey: "AIzaSyDXTNgPdRlVHl-EAFwL_pasXOCuAvCDXSc",
    authDomain: "smartqa-staging.firebaseapp.com",
    databaseURL: "https://smartqa-staging.firebaseio.com",
    projectId: "smartqa-staging",
    storageBucket: "smartqa-staging.appspot.com",
    messagingSenderId: "154257787613",
    appId: "1:154257787613:web:6746fb83037fbcba1fa934"
};
